module.exports = __webpack_public_path__ + "img/pic4.2f0ab58c.png";